export const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      localStorage.setItem("isAuthenticated", true);
      // localStorage.setItem("username", action.payload.username);
      // localStorage.setItem("role", action.payload.role);
      // localStorage.setItem("enrollmentStatus", action.payload.enrollmentStatus);
      return {
        ...state,
        isAuthenticated: true,
        username: action.payload.username,
        role: action.payload.role,
        enrollmentStatus: action.payload.enrollmentStatus,
      };
    case "LOGOUT":
      localStorage.clear();
      // localStorage.removeItem("isAuthenticated");
      // localStorage.removeItem("username");
      // localStorage.removeItem("role");
      // localStorage.removeItem("enrollmentStatus");
      return {
        ...state,
        isAuthenticated: false,
        username: "",
        role: "",
        enrollmentStatus: false,
      };
    case "SET_ENROLLMENT_STATUS":
      localStorage.setItem("enrollmentStatus", action.payload);
      return {
        ...state,
        enrollmentStatus: action.payload,
      };
    default:
      return state;
  }
};
